import {Component, Input, OnInit} from '@angular/core';
import {OrderItemModel} from "../../models/orders/order-item.model";
import {ActivatedRoute, Router} from "@angular/router";
import {OrderModel} from "../../models/orders/order.model";
import {AddNoteComponent} from "../waiter-table/add-note/add-note.component";
import {DialogService} from "primeng/dynamicdialog";
import {TranslateService} from "@ngx-translate/core";
import {OrderService} from "../../services/order/order.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {AuthenticationService} from "../../../share-modul/services/authentication/authentication.service";
import {Subject, takeUntil} from "rxjs";
import {CurrencyModel} from "../../models/menu/currency-model";

@Component({
  selector: 'app-display-order',
  templateUrl: './display-order.component.html',
  styleUrls: ['./display-order.component.scss']
})
export class DisplayOrderComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public tableId: string;
  public venueId: string;
  public order: OrderModel = new OrderModel();
  public currency: CurrencyModel = new CurrencyModel();
  public orderBillNumber: string = "";
  public editMode: boolean = false;
  public spinner: boolean = false;
  public state: Array<OrderItemModel> = [];
  public currentWaiter: any;


  constructor(public route: ActivatedRoute,
              private router: Router,
              public authenticationService: AuthenticationService,
              public dialogService: DialogService,
              public messageService: MessageService,
              public translate: TranslateService,
              public orderService: OrderService,
              private confirmationService: ConfirmationService

) {
    let state = this.router.getCurrentNavigation()?.extras.state;
    this.order = (<OrderModel> state?.order);
    this.currency = (<CurrencyModel> state?.currency);
    this.orderBillNumber = state?.orderBillNumber;

    this.route.params.subscribe(async params => {
      this.tableId = params['table-id'];
      this.venueId = params['venue-id'];
      if (!this.order){
        this.navigateToOrderTable();
      }
    });
    this.order.items.forEach(val => this.state.push(Object.assign(new OrderItemModel(), val)));
    this.authenticationService.getWaiterProfile().subscribe(response => {
      this.currentWaiter = response;
      this.order.venueEmployeeId = this.currentWaiter.id;
    });
  }

  ngOnInit(): void {
  }

  addNote() {
    const ref = this.dialogService.open(AddNoteComponent, {
      data: {
        note: this.order.note
      },
      header: this.translate.instant('ORDER.ADD_NOTE'),
      height: '350px',
      width: '400px',
      styleClass: "note_dialog_style"
    });
    ref.onClose.subscribe((response: any) => {
      if(response){
        this.order.note = response;
      }
    });
  }

  createOrder(){
    this.orderService.addOrder(this.order)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
      response => {
        this.spinner = false;
        this.messageService.add({severity:'success', summary: this.translate.instant("ORDER.ADDED_ORDER"), life: 3000});
        this.navigateToOrderTable();
      },
      error => {
        this.spinner = false;
        if(error.error.StatusCode == -318){
          this.confirmationService.confirm({
            message: this.translate.instant("ORDER.PROCEED_MISSING_INGREDIENTS_ORDER"),
            acceptLabel: this.translate.instant("PROCEED").toUpperCase(),
            rejectLabel: this.translate.instant("CANCEL").toUpperCase(),
            defaultFocus: "reject",
            accept: () => {
              this.order.needValidation = false;
              this.createOrder();
            }
          });
        }
        if(error.error.StatusCode == -317){
          this.messageService.add({ severity: 'error', summary: error.error.Message, life: 2000 });
        }
      }
    )
  }
  disabledOrderCreation(){
      return this.order.items.every(item => item.quantity == 0);
  }
  increaseQuantity(item: OrderItemModel){
    item.quantity = item.quantity + 1;
    this.order.price += item.venueMenuItemPrice;
    this.order.priceWithTax += item.venueMenuItemPriceWithTax;
  }
  decreaseQuantity(item: OrderItemModel){
    item.quantity = item.quantity - 1;
    this.order.price -= item.venueMenuItemPrice;
    this.order.priceWithTax -= item.venueMenuItemPriceWithTax;
  }
  changeEditMode(){
    if(this.editMode) {
      this.state =  [];
      this.order.items.forEach(val => this.state.push(Object.assign(new OrderItemModel(), val)));
    }
    this.editMode = !this.editMode;
  }
  cancelEdit(){
    this.editMode = !this.editMode;
    this.order.items = [];
    this.order.price = 0;
    this.order.priceWithTax = 0;
    this.state.forEach(val => {
      this.order.items.push(Object.assign(new OrderItemModel(), val))
      this.order.price += val.venueMenuItemPrice * val.quantity;
      this.order.priceWithTax += val.venueMenuItemPriceWithTax * val.quantity;
    });
  }

  cancelOrder(){
    this.confirmationService.confirm({
      message: this.translate.instant("ORDER.CANCEL_ORDER"),
      acceptLabel: this.translate.instant("PROCEED").toUpperCase(),
      rejectLabel: this.translate.instant("CANCEL").toUpperCase(),
      defaultFocus: "reject",
      accept: () => {
        this.navigateToOrderTable();
      }
    });
  }

  navigateToOrderTable(){
    this.router.navigateByUrl('/waiter/' + this.venueId + '/wtr/' + this.tableId + '/table');
  }
  returnStateToOrderTable(){
    this.router.navigateByUrl('/waiter/' + this.venueId+ '/wtr/' + this.tableId + '/table', {state: {order: this.order}});
  }

}
